var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8575 15.082C14.7207 14.8614 16.5513 14.4217 18.3115 13.772C16.8209 12.1208 15.9972 9.9745 16.0005 7.75V7.05V7C16.0005 5.4087 15.3683 3.88258 14.2431 2.75736C13.1179 1.63214 11.5918 1 10.0005 1C8.40918 1 6.88305 1.63214 5.75784 2.75736C4.63262 3.88258 4.00048 5.4087 4.00048 7V7.75C4.00349 9.97463 3.17946 12.121 1.68848 13.772C3.42148 14.412 5.24848 14.857 7.14348 15.082M12.8575 15.082C10.9595 15.3071 9.04149 15.3071 7.14348 15.082M12.8575 15.082C13.0016 15.5319 13.0374 16.0094 12.9621 16.4757C12.8867 16.942 12.7023 17.384 12.4239 17.7656C12.1454 18.1472 11.7808 18.4576 11.3597 18.6716C10.9386 18.8856 10.4729 18.9972 10.0005 18.9972C9.5281 18.9972 9.0624 18.8856 8.64128 18.6716C8.22017 18.4576 7.85555 18.1472 7.5771 17.7656C7.29865 17.384 7.11424 16.942 7.03889 16.4757C6.96354 16.0094 6.99937 15.5319 7.14348 15.082",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.eee104491fae1a9405afb4330fe47d2f.svg";
export { ForwardRef as ReactComponent };